<template>
  <div class="login">
    <el-form
            :rules="rules"
            ref="ruleForm"
            :model="form"
            class="login-form"
    >
      <h3 class="title">
        <img :src="logo" style="width: 85%"/>
      </h3>
      <el-form-item prop="userCode">
        <el-input v-model="form.userCode" @keydown.enter.native="handleLoginSureClick" type="text"
                  auto-complete="off" placeholder="用户">
          <svg-icon
                  slot="prefix"
                  icon-class="user"
                  class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
                v-model="form.password"
                @keydown.enter.native="handleLoginSureClick"
                type="password"
                auto-complete="off"
                placeholder="密码"
        >
          <svg-icon
                  slot="prefix"
                  icon-class="password"
                  class="el-input__icon input-icon"
          />
        </el-input>
      </el-form-item>

      <el-checkbox
              v-model="checked" @change="checkedchange"
              style="margin: 0px 0px 25px 0px; color: #fff"
      >自动登录</el-checkbox
      >
      <el-form-item style="width: 100%">
        <el-button
                size="medium"
                type="primary"
                style="width: 100%"
                @click.native.prevent="handleLoginSureClick"
        >
          <span>登 录</span>
        </el-button>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
       <span>copyright©莱维塞尔2022</span>
    </div>
  </div>
</template>
<script>
  /**
   * 注意此文件会在没有router的环境下使用，请谨慎使用全局router相关的变量
   * 本文件会拷贝到其他项目使用，
   */
  import { mapState } from 'vuex';
  import { setToken } from '@/utils';

  export default {
    data() {
      return {
        logo: require('@/asset/logo.png'),
        checked: false,
        rules: {
          userCode: [{ required: true, message: '请输入账户名' }],
          password: [{ required: true, message: '请输入密码' }]
        },

        form: {
          userCode: null,
          password: null
        },


      };
    },

    // created() {
    //   // const userCodek =  localStorage.getItem('userCode')
    //   //  const passwordk =  localStorage.getItem('password')
    //   //  const checked =  localStorage.getItem('checked')
    //   //  localStorage.setItem('checked', JSON.stringify(this.checked))
    //   //  console.log(userCodek,'222')
    //   //  console.log(passwordk,'222')
    //   //  console.log(checked,'222')
    //   const checked = localStorage.getItem('checked')
    //   if (checked == true) {
    //     const userCode = localStorage.getItem('userCode')
    //     const password = localStorage.getItem('password')
    //     this.form.userCode = userCode;
    //     this.form.password = password;
    //     this.checked = true
    //   }
    // },
    mounted() {
      this.getCookie()
    },

    methods: {

      setCookie(c_name, c_pwd, c_state, exdays) {
        const exdate = new Date()
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
        window.document.cookie = 'userCode' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString()
        window.document.cookie = 'password' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString()
        window.document.cookie = 'checked' + '=' + c_state + ';path=/;expires=' + exdate.toGMTString()
      },
      getCookie() {
        if (document.cookie.length > 0) {
          const arr = document.cookie.split('; ')
          for (let i = 0; i < arr.length; i++) {
            const arr2 = arr[i].split('=')
            console.log(arr[2])
            if (arr2[0] === 'userCode') {
              this.form.userCode = arr2[1]
            } else if (arr2[0] === 'password') {
              this.form.password = arr2[1]
            } else if (arr2[0] === 'checked') {
              this.checked = Boolean(arr2[1])
            }
          }
        }
      },
      // 清除cookie
      clearCookie() {
        this.setCookie('', '', false, -1)

      },

      checkedchange() {
        // console.log(this.checked)
      },
      handleLoginSureClick() {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.$postForm('/windfarm/doLogin', {
              showError: true,
              showSuccess: true,
              showLoading: true,
              data: {
                ...this.form
              }
            }).then(res => {
              // console.log(this.form.password, '555')
              // console.log(this.form.userCode, '555')
              if (this.checked === true) {
                this.setCookie(this.form.userCode, this.form.password, true, 7)
              } else {
                this.clearCookie()
              }

              // if (this.checked == true) {

              //   localStorage.setItem('userCode', JSON.stringify(that.form.userCode))
              //   localStorage.setItem('password', JSON.stringify(that.form.password))
              //   localStorage.setItem('checked', JSON.stringify(this.checked))
              //   this.checked = true
              // }

              const { data = {} } = res;
              const { user = {} } = data;


              const { apikey = '', functionMenu = {} } = user;
              setToken(apikey);
              let permissionList = functionMenu.map(item => {
                return item.functionCode;
              });

              // console.log(permissionList)
              this.$store.commit('SET_USER', res.data?.user);
              this.$store.commit('SET_PERMISSION', permissionList);

              const { callbackUrl = '' } = this.$route.query;

              if (this.$route.name === 'list') {
                location.reload();
              }
              if (callbackUrl) {
                this.$router.replace({
                  path: callbackUrl
                });
              }
              this.$router.push('/list')
            });
          }
        });
      },

    },



    computed: {
      ...mapState(['user']),
      isRoot() {
        return this.$route && this.$route.name === 'root';
      }
    }
  };
</script>

<style lang="less" scoped>
  .login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-image: url("../asset/bg.jpg");
    background-size: cover;
    color: #fff;
  }
  .title {
    margin: 0px auto 30px auto;
    text-align: center;
    color: #707070;
    font-size: 18px;
  }

  .login-form {
    border-radius: 6px;
    background: rgba(0,0,0,.3);
    width: 400px;
    padding: 25px 25px 25px 25px;
    margin-left: 45%;
    .el-input {
      height: 38px;
      input {
        height: 38px;
      }
    }
    .input-icon {
      height: 39px;
      width: 14px;
      margin-left: 2px;
    }
  }
  .login-tip {
    font-size: 13px;
    text-align: center;
    color: #bfbfbf;
  }
  .login-code {
    width: 33%;
    height: 38px;
    float: right;
    img {
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .el-login-footer {
    height: 40px;
    line-height: 40px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: Arial;
    font-size: 12px;
    letter-spacing: 1px;
  }
  .login-code-img {
    height: 38px;
  }
  /deep/ .el-checkbox__label {
    // color: #fff !important;
  }
  /deep/ .el-input--small .el-input__inner{
    line-height: 38px;
    height: 38px;
  }
</style>
